<template>
  <div v-loading="loading" class="main">
    <div class="tab_content">
      <div
        class="tab_content_each"
        v-for="(item, index) in options"
        :key="index"
        @click="selectType(item)"
        :class="{ active: item.value == listQuery.method }"
      >
        {{ item.label }}
      </div>
    </div>
    <div v-if="listQuery.method == 'invoice'">
      <div class="tab_content_btn" v-if="comInfo.automatic === 1">
        {{ $filterAutoStatusText(invoiceData.confirmStatus, "qr") }}
      </div>
      <div class="tab_content_btn" v-else>
        {{ $homeConfirmStatus(invoiceData.confirmStatus) }}
      </div>
      <div class="each_main">
        <div class="record">销项发票</div>
        <div class="fw_date">本月开具：{{ invoiceData.outCount || 0 }}</div>
        <div class="fw_date">金额：{{ $comdify(invoiceData.outAmount) }}</div>
        <div class="fw_date">税额：{{ $comdify(invoiceData.outTax) }}</div>
        <div class="fw_date">
          价税合计：{{ $comdify(invoiceData.outTotal) }}
        </div>
      </div>
      <div class="each_main">
        <div class="record">进项发票</div>
        <div class="fw_date">本月取得：{{ invoiceData.inCount || 0 }}</div>
        <div class="fw_date">金额：{{ $comdify(invoiceData.inAmount) }}</div>
        <div class="fw_date">税额：{{ $comdify(invoiceData.inTax) }}</div>
        <div class="fw_date">价税合计：{{ $comdify(invoiceData.inTotal) }}</div>
      </div>
      <div class="send_btn">
        <div @click="sendCat()">
          <el-icon> <Position /> </el-icon>告知客户
        </div>
        <div @click="confirmBill">
          <el-icon> <Checked /> </el-icon>确认
        </div>
      </div>
    </div>
    <div v-if="listQuery.method == 'bank'">
      <div class="tab_content_btn" v-if="comInfo.automatic === 1">
        {{ $filterAutoStatusText(bankConfirmStatus, "qr") }}
      </div>
      <div class="tab_content_btn" v-else>
        {{ $homeConfirmStatus(bankConfirmStatus) }}
      </div>
      <div v-if="bankData.length > 0">
        <div class="each_main" v-for="(item, index) in bankData" :key="index">
          <div class="record">{{ item.name }}</div>
          <div class="fw_date">交易笔数：{{ item.count }}</div>
          <div class="fw_date">收入：{{ $comdify(item.inAmount) }}</div>
          <div class="fw_date">支出：{{ $comdify(item.outAmount) }}</div>
        </div>
      </div>
      <div v-else>
        <el-empty description="暂无银行流水信息" :image-size="80" />
      </div>
      <div class="send_btn">
        <div @click="sendCat()">
          <el-icon> <Position /> </el-icon>告知客户
        </div>
        <div @click="confirmBill">
          <el-icon> <Checked /> </el-icon>确认
        </div>
      </div>
    </div>
    <div v-if="listQuery.method == 'salary'">
      <div class="tab_content_btn" v-if="comInfo.automatic === 1">
        {{ $filterAutoStatusText(salaryConfirmStatus, "qr") }}
      </div>
      <div class="tab_content_btn" v-else>
        {{ $homeConfirmStatus(salaryConfirmStatus) }}
      </div>
      <div v-if="salaryData.length > 0">
        <div class="each_main" v-for="(item, index) in salaryData" :key="index">
          <div class="record">{{ item.wageType }}</div>
          <div class="fw_date">员工人数：{{ item.personCount }}</div>
          <div class="fw_date">薪资总额：{{ $comdify(item.salaryTotal) }}</div>
          <div class="fw_date">应补退额：{{ $comdify(item.tax) }}</div>
        </div>
      </div>
      <div v-else>
        <el-empty description="暂无薪酬信息" :image-size="80" />
      </div>
      <div class="send_btn">
        <div @click="sendCat()">
          <el-icon> <Position /> </el-icon>告知客户
        </div>
        <div @click="confirmBill">
          <el-icon> <Checked /> </el-icon>确认
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, getCurrentInstance } from "vue"
import { ElMessage } from "element-plus"
import {
  invoiceInfo,
  invoiceConfirm,
  bankInfo,
  bankConfirm,
  salaryInfo,
  salaryConfirm,
  salaryExcel,
} from "@/api/receipt"
const { proxy } = getCurrentInstance()
const props = defineProps({
  period: { type: String, default: "" },
  comInfo: { type: Object, default: () => {} },
  cKey: { type: Number, default: 0 },
})
const listQuery = ref({
  method: "invoice",
  comId: null,
  period: null,
})
const comForm = ref({})
const loading = ref(false)
const options = ref([
  { label: "发票", value: "invoice" },
  { label: "银行", value: "bank" },
  { label: "薪酬", value: "salary" },
])
const invoiceData = ref({
  inCount: "",
  outCount: "",
  inTotal: "",
  outTotal: "",
  inAmount: "",
  outAmount: "",
  inTax: "",
  outTax: "",
  confirmStatus: 0,
})
const bankData = ref([])
const bankConfirmStatus = ref(0)
const salaryData = ref([])
const salaryConfirmStatus = ref(0)
const getList = () => {
  loading.value = true
  if (listQuery.value.method == "invoice") {
    invoiceInfo(listQuery.value).then((res) => {
      loading.value = false
      if (res.data.msg == "success") {
        invoiceData.value = res.data.data.info.invoiceInfo
        invoiceData.value.confirmStatus = res.data.data.info.confirmStatus
      }
    })
  } else if (listQuery.value.method == "bank") {
    bankInfo(listQuery.value).then((res) => {
      loading.value = false
      if (res.data.msg == "success") {
        bankData.value = res.data.data.info.bankInfos || []
        bankConfirmStatus.value = res.data.data.info.confirmStatus
      }
    })
  } else {
    salaryInfo(listQuery.value).then((res) => {
      loading.value = false
      if (res.data.msg == "success") {
        salaryData.value = res.data.data.info.salaryInfos || []
        salaryConfirmStatus.value = res.data.data.info.confirmStatus
      }
    })
  }
}
const selectType = (item) => {
  listQuery.value.method = item.value
  getList()
}
watch(
  () => [props.period, props.comInfo, props.cKey],
  (newVal) => {
    listQuery.value.period = newVal[0]
    listQuery.value.comId = newVal[1].id
    comForm.value = newVal[1]
    if (listQuery.value.comId) {
      getList()
    }
  },
  { immediate: true },
)
const sendText = (method) => {
  let content = `您的企业「${props.comInfo.name}」，${props.period.substring(
    0,
    4,
  )}年${props.period.substring(4, 6)}账期:\n`
  switch (method) {
    case "invoice":
      content += `进项发票采集张数：${invoiceData.value.inCount || 0}张\n`
      content += `进项价税合计：${proxy.$comdify(
        invoiceData.value.inTotal,
      )}元\n`
      content += `进项税额：${proxy.$comdify(invoiceData.value.inTax)}元\n`
      content += `销项发票采集张数：${invoiceData.value.outCount || 0}张\n`
      content += `销项价税合计：${proxy.$comdify(
        invoiceData.value.outTotal,
      )}元\n`
      content += `销项税额：${proxy.$comdify(invoiceData.value.outTax)}元\n`
      content +=
        "注:以上数据均为电子税务局-税务数字账户采集获取，最终以月末实际汇总数据为准!"
      break
    case "bank":
      if (Array.isArray(bankData.value) && bankData.value.length > 0) {
        bankData.value.forEach((bank, index) => {
          content += `银行简称：${bank.name}\n`
          content += `交易笔数：${bank.count || 0}笔\n`
          content += `银行收款金额：${proxy.$comdify(bank.inAmount)}元\n`
          content += `银行支出金额：${proxy.$comdify(bank.outAmount)}元\n`
          if (index < bankData.value.length - 2) {
            content += "\n"
          }
        })
      } else {
        content += "暂无银行流水信息"
      }
      content += `\n${props.period.substring(0, 4)}年${props.period.substring(
        4,
        6,
      )}银行流水情况如上，请确认是否有变动，如有疑问请随时沟通`
      break
    case "salary":
      if (Array.isArray(salaryData.value) && salaryData.value.length > 0) {
        salaryData.value.forEach((salary, index) => {
          content += `申报《${salary.wageType}》：\n`
          content += `员工人数：${salary.personCount || 0}人\n`
          content += `薪资总额：${proxy.$comdify(salary.salaryTotal)}元\n`
          content += `系统应补退税额：${proxy.$comdify(salary.tax)}元\n`
          if (index < salaryData.value.length - 2) {
            content += "\n"
          }
        })
      } else {
        content += "暂无薪酬信息"
      }
      content += `\n${props.period.substring(0, 4)}年${props.period.substring(
        4,
        6,
      )}账期薪酬情况如上，请确认是否有变动，如有疑问请随时沟通`
      break
  }
  return content
}
const sendCat = () => {
  console.log(sendText(listQuery.value.method))

  wx.invoke(
    "sendChatMessage",
    {
      msgtype: "text", //消息类型，必填
      enterChat: true, //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
      text: {
        content: sendText(listQuery.value.method),
      },
    },
    function (res) {
      if (
        res.err_msg == "sendChatMessage:ok" &&
        listQuery.value.method != "salary"
      ) {
        ElMessage.success("发送成功")
      }
    },
  )
  if (listQuery.value.method == "salary") {
    salaryExcel(listQuery.value).then((res) => {
      if (res.data.msg == "success") {
        res.data.data.mediaIDs?.forEach((v) => {
          wx.invoke("sendChatMessage", {
            msgtype: "file", //消息类型，必填
            file: {
              mediaid: v, //文件的素材id
            },
          })
        })
        ElMessage.success("发送成功")
      }
    })
  }
}
//单据确认
const confirmBill = () => {
  const method = listQuery.value.method
  const param = {
    comId: listQuery.value.comId,
    period: listQuery.value.period,
  }
  const confirmConfig = {
    invoice: {
      status: invoiceData.value?.confirmStatus,
      confirmFn: invoiceConfirm,
      warningMsg: "发票不是待确认状态不可确认",
    },
    bank: {
      status: bankConfirmStatus.value,
      confirmFn: bankConfirm,
      warningMsg: "银行不是待确认状态不可确认",
    },
    salary: {
      status: salaryConfirmStatus.value,
      confirmFn: salaryConfirm,
      warningMsg: "工资不是待确认状态不可确认",
    },
  }
  const config = confirmConfig[method]
  const { status, confirmFn, warningMsg } = config
  if (status !== 2 && props.comInfo.automatic === 1) {
    ElMessage.warning(warningMsg)
    return
  }
  confirmFn(param).then((res) => {
    if (res.data.msg === "success") {
      ElMessage.success("确认成功")
      getList()
    }
  })
}
</script>

<style scoped lang="scss">
.tab_content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 5px;
  background-color: #fff;
  font-size: 14px;

  .tab_content_each {
    flex: 1;
    text-align: center;
    padding: 3px 0;
    border: 1px solid #efefef;
    border-radius: 4px;
    cursor: pointer;
  }

  .active {
    color: $color-main;
  }
}

.tab_content_btn {
  text-align: right;
  margin: 10px 10px 0;
  color: #17a2b8;
}

.each_main {
  margin: 0 5px;
  border: 1px solid #efefef;
  padding-top: 10px;
  background-color: #fff;
  border-radius: 4px;
  margin-top: 10px;
}

.fw_date {
  margin: 10px 8px 15px;
  font-size: 13px;
}

.send_btn {
  margin: 10px 5px;
  display: flex;
  align-items: center;
  background-color: #fff;

  & > div {
    flex: 1;
    text-align: center;
    border: 1px solid #efefef;
    padding: 5px 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:first-child {
      color: $color-main;
    }

    &:last-child {
      color: green;
    }
  }
}
</style>
